import {
  FETCH_ALL_SUPPLIER_IMAGES,
  RESET_IMAGES,
  CLEAR_IMAGES,
  FETCH_IMAGE,
  CURRENT_SEARCH_ITEM
} from "../actions";
import _ from "lodash";

const initialState = {
  isCached: false,
  masterItemList: [],
  currentItem: ""
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_SUPPLIER_IMAGES:
      let list = _.keyBy(action.payload, "name");
      const itemList = _.uniq(
        action.payload.flatMap(image =>
          image.referenceNum.length === 9 && image.referenceNum.endsWith(".")
            ? image.referenceNum.substring(0, 8)
            : image.referenceNum
        )
      );

      return {
        ...state,
        ...list,
        isCached: true,
        masterItemList: _.sortedUniq(
          state.masterItemList.concat(itemList).sort()
        )
      };
    case RESET_IMAGES:
      return initialState;
    case CLEAR_IMAGES:
      return {
        isCached: state.isCached,
        masterItemList: [...state.masterItemList],
        currentItem: state.currentItem
      };
    case FETCH_IMAGE:
      return {
        ...state,
        [action.payload.name]: action.payload
      };
    case CURRENT_SEARCH_ITEM:
      return {
        ...state,
        currentItem: action.payload
      };
    default:
      return state;
  }
}
